import React, { useEffect, useState } from "react";
import {
  Box,
  IconButton,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  TablePagination,
} from "@mui/material";
import EditIcon from "@mui/icons-material/Edit";
import DeleteIcon from "@mui/icons-material/Delete";
import UserTopbar from "../UserTopbar";
import { useNavigate, useOutletContext } from "react-router-dom";
import UserSection from "../../Services/User/UserLogin";
import Swal from "sweetalert2";
import { deleteDraft } from "../../redux/slices/draftSlice";
import { useDispatch, useSelector } from "react-redux";
import Loader from "../utils/Loader";

const Draft = () => {
  const { isSidebarOpen } = useOutletContext();
  const [searchQuery, setSearchQuery] = useState("");
  const [draftData, setDraftData] = useState([]);
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const [loading, setLoading] = useState(false);
  const { deleteStatus } = useSelector((state) => state.draft);
  const [page, setPage] = useState(0);
  const [rowsPerPage, setRowsPerPage] = useState(10);

  const viewDraff = async () => {
    try {
      setLoading(true);
      const response = await UserSection.viewDraft();
      setDraftData(response.data || []);
    } catch (error) {
      console.error("Error fetching draft data:", error);
      Swal.fire("Error", "Could not fetch drafts.", "error");
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    viewDraff();
  }, [deleteStatus]);

  // 1. Filter the total data based on search
  const filteredData = draftData.filter((row) => {
    const combinedData = [
      (row.id || "").toString().toLowerCase(),
      (row.uid || "").toString().toLowerCase(),
      (row.client_name || "").toString().toLowerCase(),
      (row.client_id || "").toString().toLowerCase(),
    ].join(" ");
    return combinedData.includes(searchQuery.toLowerCase());
  });

  const visibleRows =
    rowsPerPage === -1
      ? filteredData
      : filteredData.slice(page * rowsPerPage, page * rowsPerPage + rowsPerPage);

  // const openDraft = (id) => {
  //   localStorage.setItem("draft_id", id);
  //   navigate(`/user/projects`);
  // };

  // const openDraft = (id) => {
  //   navigate(`/user/create-quote/draft-${id}`);
  // };

  const openDraft = (id, uid) => {
    // navigate(`/user/create-quote/0/Select-Client/draft-${id}`, {
    //   state: { uid }
    // });

       navigate(`/user/create-quote-fx/0/Select-Client/draft-${id}`, {
      state: { uid }
    });
  };

  const deletedraft = (id) => {
    dispatch(deleteDraft(id));
  };

  const handleChangePage = (event, newPage) => {
    setPage(newPage);
  };

  const handleChangeRowsPerPage = (event) => {
    const val = parseInt(event.target.value, 10);
    setRowsPerPage(val);
    setPage(0);
  };

  let isPending = loading || deleteStatus === "pending";

  return (
    <>
      {/* Loader removed, using Skeleton below */}

      <UserTopbar heading="Draft" sidebar={isSidebarOpen} />
      <div className=" h-[88vh] p-2 shadow-xl mx-auto">
        {loading ? (
          <div className="w-full mt-2 bg-white/60 backdrop-blur-md rounded-2xl shadow-lg border border-white/50 overflow-hidden">
            <div className="bg-white/50 p-5 flex justify-between items-center border-b border-white/50">
              <div className="h-10 w-[27rem] bg-gray-200 rounded-full animate-pulse"></div>
            </div>
            <div className="p-0">
              <div className="flex gap-4 p-4 bg-white/40 border-b border-white/50">
                {[1, 2, 3, 4, 5, 6, 7].map(i => (
                  <div key={i} className="h-4 bg-gray-200 rounded animate-pulse flex-1"></div>
                ))}
              </div>
              {[1, 2, 3, 4, 5, 6].map((row) => (
                <div key={row} className="flex gap-4 p-4 border-b border-white/30 items-center">
                  {[1, 2, 3, 4, 5, 6, 7].map(col => (
                    <div key={col} className="h-6 bg-white/60 rounded animate-pulse flex-1"></div>
                  ))}
                </div>
              ))}
            </div>
          </div>
        ) : (
          <>
            <div className="bg-white/60 backdrop-blur-md rounded-2xl shadow-lg border border-white mt-4 overflow-hidden">
              <Box
                className="bg-white/50 p-4 border-b border-white/50"
                sx={{
                  display: "flex",
                  justifyContent: "space-between",
                  alignItems: "center",
                }}
              >
                <div className="flex justify-between items-center">
                  <input
                    type="text"
                    onChange={(e) => {
                      setSearchQuery(e.target.value);
                      setPage(0);
                    }}
                    placeholder="Search by draft-Id..."
                    className="pl-6 pr-4 py-2.5 w-[27rem] border border-gray-300 rounded-full text-gray-700 bg-white/80 focus:bg-white focus:outline-none focus:ring-2 focus:ring-[#ff7b00]/50 focus:border-[#ff7b00] transition-all shadow-sm"
                    required
                  />
                </div>
              </Box>

              <div className="overflow-x-auto">
                <TableContainer sx={{ minHeight: "calc(100vh - 280px)", maxHeight: "calc(100vh - 280px)" }}>
                  <Table stickyHeader>
                    <TableHead>
                      <TableRow>
                        {["Sr No", "Draft Id", "Client Name", "Client Id", "Created On", "Last Modified", "Actions"].map((header) => (
                          <TableCell
                            key={header}
                            className="bg-white/40 border-b border-white/50"
                            style={{ color: "#1e293b", fontWeight: "bold" }}
                          >
                            {header}
                          </TableCell>
                        ))}
                      </TableRow>
                    </TableHead>
                    <TableBody>
                      {visibleRows.length === 0 ? (
                        <TableRow>
                          <TableCell colSpan={7} align="center">
                            No data available
                          </TableCell>
                        </TableRow>
                      ) : (
                        visibleRows.map((row, index) => (
                          <TableRow key={row.id}>
                            <TableCell>
                              {rowsPerPage === -1 ? index + 1 : page * rowsPerPage + index + 1}
                            </TableCell>
                            <TableCell>{row.uid}</TableCell>
                            <TableCell>{row.client_name}</TableCell>
                            <TableCell>{row.client_id}</TableCell>
                            <TableCell>
                              {new Date(row.created_at).toLocaleDateString("en-GB", {
                                day: "2-digit",
                                month: "short",
                                year: "numeric",
                                hour: "2-digit",
                                minute: "2-digit",
                              })}
                            </TableCell>
                            <TableCell>
                              {new Date(row.updated_at).toLocaleDateString("en-GB", {
                                day: "2-digit",
                                month: "short",
                                year: "numeric",
                                hour: "2-digit",
                                minute: "2-digit",
                              })}
                            </TableCell>
                            <TableCell>
                              <div className="flex space-x-2">
                                <IconButton color="primary" onClick={() => openDraft(row.id, row.uid)}>
                                  <EditIcon />
                                </IconButton>
                                <IconButton color="secondary" onClick={() => deletedraft(row.id)}>
                                  <DeleteIcon />
                                </IconButton>
                              </div>
                            </TableCell>
                          </TableRow>
                        ))
                      )}
                    </TableBody>
                  </Table>
                </TableContainer>

                <TablePagination
                  sx={{ backgroundColor: "rgba(255, 255, 255, 0.4)" }}
                  className="border-t border-white/50 text-[#1e293b]"
                  rowsPerPageOptions={[10, 50, 100, 500, filteredData.length]}
                  component="div"
                  count={filteredData.length}
                  rowsPerPage={rowsPerPage}
                  page={page}
                  onPageChange={handleChangePage}
                  onRowsPerPageChange={handleChangeRowsPerPage}
                />
              </div>
            </div>
          </>
        )}
      </div>
    </>
  );
};

export default Draft;